export default {
    centerAlign: {
        justifyContent: "center",
        alignItems: "center",
    },

    headerColor: {
        backgroundColor: "#fff",
    },

    headerTitle: {
        color: "#000",
        fontSize: 17,
    },

    headerColorGroup: {
        backgroundColor: "#ffb007",
    },

    headerIcon: {
        fontSize: 30,
        color: "#777",
    },
    eyeIcon: {
        fontSize: 24,
        marginLeft: 10,
    },
    headerImage: {
        width: 44,
        height: 44,
        borderRadius: 44,
        resizeMode: "cover",
        borderWidth: 2,
        borderColor: "rgba(0,0,0,.06)",
    },
    groupImage: {
        width: 44,
        height: 44,
        resizeMode: "cover",
        borderWidth: 2,
        borderColor: "rgba(0,0,0,.06)",
    },
    imageMember: {
        width: 16,
        height: 15,
        left: 15,
        top: -8,
    },
    closeIcon: {
        color: "#2D2D2D",
    },
    closeIconSize: {
        fontSize: 30,
    },

    flex1: {
        flex: 1,
    },

    flex3: {
        flex: 3,
    },

    alignItemsCenter: {
        alignItems: "center",
    },

    marginHorizontal16: {
        marginHorizontal: 16,
    },

    marginVertical12: {
        marginVertical: 12,
    },

    marginVertical10: {
        marginVertical: 10,
    },

    marginTop20: {
        marginTop: 20,
    },

    marginTop2: {
        marginTop: 2,
    },

    flexDirection: {
        flexDirection: "row",
    },

    book: {
        backgroundColor: "#f4f4f4",
        borderRadius: 6,
        height: 60,
    },

    bookText: {
        fontSize: 14,
        color: "#666",
        fontWeight: "700",
    },

    bookDetail: {
        fontSize: 12,
        color: "#999",
    },

    marginBottom30: {
        marginBottom: 30,
    },

    marginBottom10: {
        marginBottom: 10,
    },

    testButton: {
        marginTop: 40,
        borderRadius: 30,
        backgroundColor: "rgb(100,218,73)",
        width: 220,
    },

    testText: {
        textAlign: "center",
        fontSize: 16,
        color: "#fff",
    },

    chooseBook: {
        color: "#5cb85c",
    },

    borderBook: {
        height: 1,
        backgroundColor: "#5cb85c",
        width: 120,
        marginTop: 3,
    },

    rowContainer: {
        flexDirection: "row",
        marginTop: 20,
        marginHorizontal: 5,
        justifyContent: "center",
        alignItems: "center",
    },
    border: {
        borderWidth: 1,
        borderRadius: 2,
    },
    borderBlue: {
        borderColor: "#1754a2",
    },
    borBottom: {
        borderBottomWidth: 1,
        borderBottomColor: "#858585",
    },
    moreText: {
        fontSize: 12,
        color: "#999",
    },
    textIcon: {
        fontSize: 16,
        color: "#999",
    },

    //头部导航栏body左边距
    headerBodyMgLeft: {
        marginLeft: 10,
    },
    //头部导航栏下面的那根线，暂时隐藏了
    headerBottomLine: {
        backgroundColor: "#858585",
        height: 1,
        display: "none",
    },
    headerBody: {
        flexDirection: "row",
        alignItems: "center",
    },
    //头部导航显示拼音、翻译、答案的默认、选中颜色
    headerRightIconDefColor: {
        color: "#858585",
    },
    headerRightIconSelectedColor: {
        color: "#ffb400",
    },
    headerRightIconLetter: {
        fontSize: 24,
        left: -13,
    },
    headerRightIconTrans: {
        fontSize: 18,
        //top:6
    },

    //头部导航栏拼音翻译显示答案的间距、
    headerRightIconPad: {
        paddingLeft: 10,
    },

    headerRightIconPinyinPad: {
        paddingTop: 2,
    },

    headerRightIconTransPad: {
        paddingTop: 5,
    },
};
